module.exports = __webpack_public_path__ + "static/media/bg31.4a59c5ee.jpg";